export default __webpack_public_path__ + "static/media/Communion-Cake-2.403c026d.jpg";